import * as Yup from 'yup';

export const REQUIRED_FIELD_MESSAGE = 'This is a required field.';

// validation rules
export const required = (requiredMessagge = REQUIRED_FIELD_MESSAGE) =>
  Yup.string().trim().required(requiredMessagge);

export const requiredSelect = (requiredMessagge = REQUIRED_FIELD_MESSAGE) =>
  Yup.object().required(requiredMessagge);

export const requiredNumber = (requiredMessagge = REQUIRED_FIELD_MESSAGE) =>
  Yup.number().required(requiredMessagge);

export const email = (emailMessagge = 'Invalid email form.') => Yup.string().email(emailMessagge);

export const urlChecker = (urlMessage = 'Invalid URL form') => Yup.string().url(urlMessage);

export const minLength = (
  min = 3,
  minLengthMessagge = `This must be at least ${min} characters long.`
) => Yup.string().trim().min(min, minLengthMessagge);

export const maxLength = (
  max = 20,
  maxLengthMessagge = `This must be less than ${max} characters.`
) => Yup.string().max(max, maxLengthMessagge);

export const imageUpload = () => Yup.string().required('You must upload the photo');

export const isNumber = (min = 1) => {
  return Yup.number()
    .typeError('Only numbers allowed')
    .integer('Only integers allowed')
    .min(min, `This must be greater than or equal to ${min}`);
};

export const requiredMultiSelect = (requiredMessagge = REQUIRED_FIELD_MESSAGE) =>
  Yup.array()
    .min(1, requiredMessagge)
    .of(
      Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable()
    );
export const minNumber = (
  min = 3,
  minNumberMessage = `This must be greater or equal than ${min}`
) => Yup.number().min(min, minNumberMessage);

export const maxNumber = (max = 50, maxNumberMessage = `This must be less or equal than ${max}`) =>
  Yup.number().max(max, maxNumberMessage);

export const rangeNumber = (
  min = 0,
  max = 50,
  minMaxNumberMessage = `Number must be from ${min} to ${max}`
) => Yup.number().min(min, minMaxNumberMessage).max(max, minMaxNumberMessage);

// validation functions
const validate = async (schema, value) =>
  schema
    .validate(value)
    .then(() => undefined)
    .catch((e) => e.message);

export const schemaValidate = (schemas) => async (value) => {
  if (schemas && schemas.length > 0) {
    let schemaCompose = Yup.mixed();
    schemas.forEach((sch) => {
      schemaCompose = schemaCompose.concat(sch);
    });
    return validate(schemaCompose, value);
  }
  return validate(schemas, value);
};

export const isHttpUrl = (string) => {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === 'http:';
};

export const noValidation = () => false;
